// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as MuiCore from '@material-ui/core';
import * as MuiPickers from '@material-ui/pickers';
import * as ServiceIcons from './Icons';
import AddIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';

import { withStyles } from '@material-ui/styles';

import OutlinedPopover from '../ui/OutlinedPopover';

import * as coreSelectors from '../core/selectors';
import * as serviceSelectors from './selectors';
import * as serviceActions from './actions';
// import * as Formatters from '../ui/Formatters';
// import { Stats } from 'fs';

const styles = theme => ({
    statusIcons:{
        display:'flex',
        flexDirection:'row',
        marginTop:20,
        cursor: 'pointer'
    },
});

const FromRight = React.forwardRef(function FromRight(props, ref) {
    return <MuiCore.Slide direction="left" ref={ref} {...props} />;
  });

class RubyStatus extends Component {
    constructor (props) {
        super(props);
        this.durationSelectLabel = React.createRef();
    }

    componentDidMount(){
        document.title = 'Ruby - Status';
    }

    state = {
        durationLabelWidth : 0,
        savingStatus: false,
        savingStatusId: '',
        removeStatus: false,
        removeStatusId: '',
        cancelStatus: false,
        cancelStatusId: '',
        cancelStatusScheduleId: '',
        schedulingStatus : false,
        scheduleStatus: {},
        scheduleOverlap: false,
        scheduleOverlapMessage: '',
        searchText:''
    }

    formatDate = (status) => {
        let startDate = new Date(status.startTime).toLocaleString('default', {month: 'short', day: 'numeric', weekday: 'short'});
        let endDate = "";
        if(Boolean(status.endTime)){
            endDate = new Date(status.endTime).toLocaleString('default', {month: 'short', day: 'numeric', weekday: 'short'});
        }else{
            endDate = "Until further notice";
        }
        if(startDate === endDate){
            return startDate;
        }else{
            return `${startDate} - ${endDate}`;
        }
    }

    formatTime = (status) => {
        let startTime = new Date(status.startTime).toLocaleString('default', {timeStyle: 'short'}).replace(" ", "").toLowerCase();
        let endTime = "";
        if(Boolean(status.endTime)){
            endTime = new Date(status.endTime).toLocaleString('default', {timeStyle: 'short'}).replace(" ", "").toLowerCase();
        }
        if(endTime === ""){
            return startTime;
        }
        return `${startTime} - ${endTime}`;
    }

    formatDateTime = (status) => {
        let startTime = new Date(status.startTime).toLocaleString('default', {month: 'short', day: 'numeric', weekday: 'short'}) + 
                            ", " + 
                            new Date(status.startTime).toLocaleString('default', {timeStyle: 'short'}).toLowerCase();
        let endTime = "";
        if(Boolean(status.endTime)){
            endTime = new Date(status.endTime).toLocaleString('default', {month: 'short', day: 'numeric', weekday: 'short'}) + 
                            ", " + 
                            new Date(status.endTime).toLocaleString('default', {timeStyle: 'short'}).toLowerCase();
        }else{
            endTime = "Until further notice";
        }
        return `${startTime} - ${endTime}`; 
    }

    formatExceptions = (exceptions) => {
        let returnString = "";
        if(exceptions.length === 1){
            returnString += exceptions[0].exceptionName;
        }else {
            exceptions.forEach((item, index) => {
                if(index === exceptions.length - 1){
                    returnString = returnString.slice(0, -2);
                    returnString += " or " + item.exceptionName;
                }else{
                    returnString += item.exceptionName + ", "
                }
            })
        }
        return returnString;
    }

    formatContacts = (contacts) => {
        let returnString = "";
        if(contacts.length === 0){
            returnString += "Cell";
        }
        if(contacts.length === 1){
            returnString += contacts[0].contactData.slice(2);
        }else {
            contacts.forEach((item, index) => {
                if(index === contacts.length - 1){
                    returnString = returnString.slice(0, -2);
                    returnString += " or " + item.contactData.slice(2);
                }else{
                    returnString += item.contactData.slice(2) + ", "
                }
            })
        }
        return returnString;
    }

    getMessageFromStatus = (status) => {
        let finalString = "";
        if(status.status.takingCalls === 'N'){
            if(status.status.messageStatusText ==="No Message"){
                finalString += "We'll hold your calls. ";
            }else{
                finalString += "We'll tell callers you are " + status.status.messageStatusText.toLowerCase() + ". ";
            }
            
            if(status.status.instructionStatusText !== 'No Instructions'){
                finalString += "We'll " + status.status.instructionStatusText.toLowerCase() + ". ";
            }
            if(status.status.exceptions.length !== 0){
                finalString += "If " + this.formatExceptions(status.status.exceptions) + " calls, ";
                if(status.status.contacts !== undefined){
                    finalString += "we'll try to reach you at " + this.formatContacts(status.status.contacts) + ". ";
                }
            }
        } else if(status.status.takingCalls === 'Y'){
            if(status.status.exceptions.length !== 0){
                if(status.status.contacts !== undefined){
                    finalString += "We'll try to reach you at " + this.formatContacts(status.status.contacts) + ". ";
                }
                if(status.status.exceptions !== undefined){
                    finalString += "We won't try your line if " + this.formatExceptions(status.status.exceptions) + " calls. ";
                }
            } else {
                finalString += "We'll try your line. ";
            }
        }
        return finalString;
    }

    editStatus = (status, startTime, endTime) => {
        let editStatus = { ...status,
                           takingCalls : status.takingCalls === 'Y',
                           saved : status.saved === 'Y'};
        editStatus.startTime = startTime;
        editStatus.endTime = endTime;
        if (!editStatus.instructionCode) {
          editStatus.instructionCode = 'NONE';
        }
        if (!editStatus.messageCode) {
          editStatus.messageCode = 'DEFAULT';
        }
    
    
          
        this.props.setStatus(editStatus);
        this.props.setStatusOpen(true);
        
    }    

    addStatus = () => {
        this.props.updateStatusSelectionLists();
        this.props.setStatus({saved: false,
                                statusName : 'One Time',
                                takingCalls : false,
                                durationCode : 'DAY',
                                startTime : null,
                                endTime : null,
                                exceptions: [],
                                contacts: [],
                                messageCode : 'DEFAULT',
                                instructionCode : 'NONE',
                                instructions : ''});
        this.props.setStatusOpen(true);
    }

    render() {
        const { classes, user, statusSelectionLists, dashboard } = this.props;
        const { scheduleStatus } = this.state;

        const validStatuses = user?.scheduledStatuses?.filter(status => (new Date(status.endTime).getTime() > new Date().getTime()) || (status.endTime === undefined));
        const currentStatus = validStatuses?.filter(status => (new Date(status.startTime).getTime() < new Date().getTime() && new Date(status.endTime).getTime() > new Date().getTime()) || (new Date(status.startTime).getTime() < new Date().getTime() && status.endTime === undefined))[0];

        let timeWarnings='';
        if (this.state.schedulingStatus && scheduleStatus.durationCode === 'CUSTOM') {
        if (scheduleStatus.endTime !== null && scheduleStatus.startTime != null) {
            if (scheduleStatus.endTime.getTime() < scheduleStatus.startTime.getTime()) {
            timeWarnings='The end time is before the start time.';
            }
        }
        if (scheduleStatus.endTime !== null) {
            if (scheduleStatus.endTime.getTime() < Date.now()) {
            timeWarnings='The end time is in the past.';
            }
        }
        }
        if (this.state.schedulingStatus && scheduleStatus.startTime != null) {
        if (scheduleStatus.startTime.getTime() < Date.now()) {
            timeWarnings='The start time is in the past.';
        }
        }

        return(
            <React.Fragment>
                <MuiCore.Dialog open={this.state.cancelStatus}
                        maxWidth='xs'
                        TransitionComponent={FromRight}
                        onClose={() => this.setState({cancelStatus: false})}>
                    <MuiCore.DialogTitle style={{textAlign: 'center'}}>
                        <span style={{fontFamily: 'Sofia-bold', fontSize: 28}}>{this.state.cancelStatusId === currentStatus?.status?.statusId ? 'Clear status' : 'Delete status'}</span>
                    </MuiCore.DialogTitle>
                    <MuiCore.DialogContent>
                        <MuiCore.DialogContentText style={{textAlign: 'center'}}>
                        <span style={{fontFamily: 'Sofia', fontSize: 16, fontWeight: 700}}>{this.state.cancelStatusId === currentStatus?.status?.statusId ? 'Are you sure you want to clear your status?' : 'Are you sure you want to delete this scheduled status?'}</span>
                        </MuiCore.DialogContentText>
                    </MuiCore.DialogContent>
                    <MuiCore.DialogActions style={{ paddingLeft: 20, paddingRight: 20 }}>
                        <MuiCore.Button onClick={() => {
                            this.props.cancelStatus(this.state.cancelStatusId, this.state.cancelStatusScheduleId);
                            this.setState({cancelStatus: false});
                            }}>
                        Delete
                        </MuiCore.Button>
                        <MuiCore.Button
                                        onClick={() => this.setState({cancelStatus: false})}>
                        Cancel
                        </MuiCore.Button>
                    </MuiCore.DialogActions>
                </MuiCore.Dialog>
                <OutlinedPopover open={this.state.schedulingStatus}
                         title={'Scheduling "' + scheduleStatus.statusName + '"'}
                         icon={scheduleStatus.takingCalls === 'N' ? <ServiceIcons.HoldCallsIcon color='secondary'/> :
                               <ServiceIcons.TakeCallsIcon color='primary'/>}
                         maxWidth='xs'
                         onClose={() => this.setState({schedulingStatus: false})}>
          <MuiCore.Grid container spacing={2} alignItems='center' direction='column'>
            <MuiCore.Grid item  style={{marginTop: 5, width: 300}}>
              <MuiPickers.DateTimePicker
                fullWidth
                className={classes.timeSelector}
                InputLabelProps={{ shrink: true}}
                clearable={true}
                disablePast={true}
                clearLabel='Now'
                ampm={true}
                format='MM/dd/yyyy hh:mm a'
                minutesStep={5}
                value={scheduleStatus.startTime}
                onChange={(value) => this.statusChange('startTime', value ? value.toJSDate() : null)}
                emptyLabel='Now'
                label='Start Time'/>
            </MuiCore.Grid>

            <MuiCore.Grid item style={{width: 300}}>
              <MuiCore.FormControl fullWidth>
                <MuiCore.InputLabel ref={this.durationSelectLabel}
                                    variant='outlined'>Duration</MuiCore.InputLabel>
                <MuiCore.Select variant='outlined'
                                onChange={(event) => this.statusChange('durationCode', event.target.value)}
                                labelWidth={this.state.durationLabelWidth}
                                value={scheduleStatus.durationCode}>
                  {(statusSelectionLists.durations || []).map(duration => {
                    let list = [];
                    if (duration.code === 'DAY' || duration.code === 'NONE' ||
                        duration.code === 'CUSTOM') {
                      list.push(<MuiCore.Divider/>);
                    }
                    list.push(<MuiCore.MenuItem key={duration.code}
                                                value={duration.code}>
                      {duration.text}
                    </MuiCore.MenuItem>);
                    return(list);
                  })}
                </MuiCore.Select>
              </MuiCore.FormControl>
            </MuiCore.Grid>
            
            <MuiCore.Grid item style={{width: 300}}>
              <MuiCore.Hidden xlDown={scheduleStatus.durationCode !== 'CUSTOM'}>
                <MuiPickers.DateTimePicker
                  fullWidth
                  disabled={scheduleStatus.durationCode !== 'CUSTOM'}
                  className={classes.timeSelector}
                  InputLabelProps={{ shrink: true }}
                  clearable={true}
                  disablePast={true}
                  ampm={true}
                  minutesStep={5}
                  format='MM/dd/yyyy hh:mm a'
                  onChange={(value) => this.statusChange('endTime', value ? value.toJSDate() : null)}
                  value={scheduleStatus.endTime}
                  clearLabel='No End'
                  emptyLabel='Until Further Notice'
                  label='Custom End Time'
                />
              </MuiCore.Hidden>
              <MuiCore.Hidden xlDown={scheduleStatus.durationCode === 'CUSTOM'}>
                <MuiCore.TextField fullWidth
                                   label='Custom End Time'
                                   disabled={true} value=''/>
              </MuiCore.Hidden>
                
            </MuiCore.Grid>

            <MuiCore.Hidden xlDown={timeWarnings.length === 0}>
              <MuiCore.Grid item>
                <MuiCore.Typography  style={{color:'#000'}}>{timeWarnings}</MuiCore.Typography>
              </MuiCore.Grid>
            </MuiCore.Hidden>
 
            <MuiCore.Grid item xs={12} style={{textAlign: 'center',
                                               paddingTop: 10}}>
              <MuiCore.Button disabled={timeWarnings.length > 0}
                              onClick={() => this.scheduleStatus(false)}>
                Schedule Status
              </MuiCore.Button>
            </MuiCore.Grid>
            
            
          </MuiCore.Grid>
        </OutlinedPopover>
                <MuiCore.Grid container>
                    <MuiCore.Grid item style={{ width: '100%', textAlign: 'center', flexDirection: 'row', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: !dashboard ? 50 : 0, marginBottom: !dashboard ? 50 : 20 }}>
                        <MuiCore.Grid style={{textAlign: 'left', height: 'auto'}}>
                            <MuiCore.Typography variant='h5' style={{fontSize:22,fontFamily:'Sofia-bold',textAlign:'center',marginTop:20, textDecoration:'underline', textDecorationColor: '#F9E7BD', textDecorationThickness: 8}}>
                                My current status
                            </MuiCore.Typography>
                            <div style={{flexDirection:'row',display:'flex',justifyContent:'center',fontFamily:'Sofia-bold'}}>
                                <div className={classes.statusIcons} onClick={() => {
                                    if(currentStatus === undefined){this.addStatus()}
                                    else{this.editStatus(currentStatus.status, currentStatus.startTime, currentStatus.endTime)}
                                }}>
                                    <ServiceIcons.EditIcon style={{marginTop: 2}} />
                                    <MuiCore.Typography variant='body2' style={{fontFamily:'Sofia-bold', marginLeft: 2, fontSize: '16px'}}>Update</MuiCore.Typography>
                                </div>
                                {currentStatus !== undefined && <div className={classes.statusIcons} onClick={() => {
                                    this.setState({cancelStatus: true,
                                        cancelStatusId: currentStatus.status.statusId,
                                        cancelStatusScheduleId: currentStatus.statusScheduleId})
                                }}>
                                    <ServiceIcons.CancelIcon style={{marginTop: 2, marginLeft: 10}} />
                                    <MuiCore.Typography variant='body2' style={{fontFamily:'Sofia-bold', marginLeft: 2, fontSize: '16px'}}>Clear</MuiCore.Typography>
                                </div>}
                            </div>
                        </MuiCore.Grid>
                        <MuiCore.Divider orientation='vertical' variant='middle' style={{ height: '100%', borderRight: '1px solid #ccc', marginTop: 20 }}></MuiCore.Divider>
                        <MuiCore.Grid style={{textAlign: 'left', height: 'auto'}}>
                            <MuiCore.Typography style={{fontSize:18,fontFamily:'Sofia-bold',marginTop:20}}>
                                {currentStatus === undefined ? 'My default call handling' : currentStatus.status.takingCalls === 'N' ? 'Not taking calls' : 'Taking calls'}
                            </MuiCore.Typography>
                            {currentStatus !== undefined && <MuiCore.Typography style={{fontSize:16,fontFamily:'Sofia-bold',marginTop:2, color: '#858DA3'}}>
                                {this.formatDateTime(currentStatus)}
                            </MuiCore.Typography>}
                            {currentStatus !== undefined && <MuiCore.Typography style={{fontSize:16,fontFamily:'Sofia',marginTop:4, display:'block'}}>
                                {/* {currentStatus.status.instructions === undefined ?  */}
                                    {this.getMessageFromStatus(currentStatus)}
                                    <div>
                                        <span style={{fontFamily: 'Sofia-bold'}}>Additional Information: </span>
                                        {currentStatus.status.instructions}
                                    </div>
                                {/* } */}
                            </MuiCore.Typography>}
                        </MuiCore.Grid>
                    </MuiCore.Grid>
                    <MuiCore.Hidden xlDown={dashboard}>
                        <MuiCore.Grid item style={{width: '100%', marginLeft: -20}}>
                            <MuiCore.Divider></MuiCore.Divider>
                            <MuiCore.Grid item style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                <MuiCore.Tabs value={0} TabIndicatorProps={{ style: { backgroundColor: "#9F5789" }}} style={{marginLeft: 30}}>
                                    <MuiCore.Tab style={{fontFamily: 'Sofia-bold', textTransform: 'none', fontSize: '16px'}} label="Scheduled"/>
                                </MuiCore.Tabs>
                                <div style={{display:'flex', flexDirection:'row', marginTop: 10, marginRight: 5, marginBottom: 10, cursor: 'pointer'}} onClick={() => {
                                    this.addStatus();
                                }}>
                                    <AddIcon style={{ marginRight: 6, color: '#7F2062', fontSize: 'medium', marginTop: 4}} />
                                    <MuiCore.Typography variant='body2' style={{fontFamily:'Sofia-bold', marginLeft: 2, fontSize: '16px'}}>New scheduled status</MuiCore.Typography>
                                </div>
                            </MuiCore.Grid>
                            <MuiCore.Divider></MuiCore.Divider>
                            <MuiCore.Hidden xlDown={validStatuses.filter(status => status?.statusId !== currentStatus?.statusId).length !== 0 }>
                                <MuiCore.Grid style={{width: '100%', textAlign: 'center', marginTop: 30}}>
                                    <mat-icon style={{widht: 20, height: 30}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24" viewBox="0 0 27.5 30" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                                            <g id="calendar-icon" transform="translate(-1005 -2655)">
                                                <rect id="Rectangle_454" data-name="Rectangle 454" width="27.5" height="27.5" rx="2" transform="translate(1005 2657.5)" fill="#ef9ca1"></rect>
                                                <rect id="Rectangle_455" data-name="Rectangle 455" width="22.5" height="6.25" transform="translate(1007.5 2660)" fill="#fff"></rect>
                                                <rect id="Rectangle_441" data-name="Rectangle 441" width="3.75" height="7.5" rx="1" transform="translate(1012.5 2655)" fill="#ef9ca1"></rect>
                                                <rect id="Rectangle_442" data-name="Rectangle 442" width="3.75" height="7.5" rx="1" transform="translate(1021.25 2655)" fill="#ef9ca1"></rect>
                                                <rect id="Rectangle_456" data-name="Rectangle 456" width="2.5" height="2.5" rx="0.5" transform="translate(1011.25 2671.25)" fill="#fff"></rect>
                                                <rect id="Rectangle_457" data-name="Rectangle 457" width="2.5" height="2.5" rx="0.5" transform="translate(1017.5 2671.25)" fill="#fff"></rect>
                                                <rect id="Rectangle_458" data-name="Rectangle 458" width="2.5" height="2.5" rx="0.5" transform="translate(1023.75 2671.25)" fill="#fff"></rect>
                                                <rect id="Rectangle_459" data-name="Rectangle 459" width="2.5" height="2.5" rx="0.5" transform="translate(1011.25 2677.5)" fill="#fff"></rect>
                                                <rect id="Rectangle_460" data-name="Rectangle 460" width="2.5" height="2.5" rx="0.5" transform="translate(1017.5 2677.5)" fill="#fff"></rect>
                                                <rect id="Rectangle_461" data-name="Rectangle 461" width="2.5" height="2.5" rx="0.5" transform="translate(1023.75 2677.5)" fill="#fff"></rect>
                                            </g>
                                        </svg>
                                    </mat-icon>
                                    <MuiCore.Typography variant='body2' style={{fontFamily:'Sofia-bold', marginLeft: 2, fontSize: '18px', marginTop: 5}}>No scheduled statuses</MuiCore.Typography>
                                    <MuiCore.Typography variant='body2' style={{fontFamily:'Sofia', marginLeft: 2, fontSize: '16px', marginTop: 5}}>Going out of town or expecting a long meeting?</MuiCore.Typography>
                                    <MuiCore.Typography variant='body2' style={{fontFamily:'Sofia', marginLeft: 2, fontSize: '16px'}}>Plan ahead by scheduling your status</MuiCore.Typography>
                                </MuiCore.Grid>
                            </MuiCore.Hidden>
                            <MuiCore.Hidden xlDown={validStatuses.length === 0 }>
                                {validStatuses.filter(status => status?.statusId !== currentStatus?.statusId).map(status => {
                                    return(
                                        <MuiCore.Grid style={{marginTop: 10}}>
                                            <MuiCore.Grid style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', margin: 20}}>
                                                <MuiCore.Grid item>
                                                    <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 18}}>{this.formatDate(status)}</MuiCore.Typography>
                                                    <MuiCore.Typography style={{fontFamily: 'Sofia-bold', color: '#707584', fontSize: 16}}>{this.formatTime(status)}</MuiCore.Typography>
                                                    <MuiCore.Typography style={{fontFamily: 'Sofia'}}>{this.getMessageFromStatus(status)}</MuiCore.Typography>
                                                    {status.status.instructions !== undefined && <MuiCore.Typography>
                                                        <span style={{fontFamily: 'Sofia-bold'}}>Additional Information: </span>
                                                        <span style={{fontFamily: 'Sofia'}}>{status.status.instructions}</span>
                                                    </MuiCore.Typography>}
                                                </MuiCore.Grid>
                                                <MuiCore.Grid item style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly'}}>
                                                    <DeleteIcon style={{margin: 10, cursor: 'pointer'}} onClick={() => {
                                                        this.setState({cancelStatus: true,
                                                            cancelStatusId: status.status.statusId,
                                                            cancelStatusScheduleId: status.statusScheduleId})
                                                    }}/>
                                                    <ServiceIcons.EditIcon style={{margin: 10, marginTop: 12, cursor: 'pointer'}} onClick={() => {
                                                        this.editStatus(status.status, status.startTime, status.endTime)
                                                    }}/>
                                                </MuiCore.Grid>
                                            </MuiCore.Grid>
                                            <MuiCore.Divider style={{marginTop: 10}}/>
                                        </MuiCore.Grid>
                                    )
                                })}
                            </MuiCore.Hidden>
                        </MuiCore.Grid>
                    </MuiCore.Hidden>
                </MuiCore.Grid>
            </React.Fragment>
        )
    }

}

const mapStateToProps = (state) => {
    return ({
        user : coreSelectors.getUser(state),
        statusSelectionLists : serviceSelectors.getStatusSelectionLists(state),
    });
  };
  
  const mapDispatchToProps = {
    setStatus: serviceActions.setStatus,
    setStatusOpen : serviceActions.setStatusOpen,
    cancelStatus : serviceActions.cancelStatus,
    updateStatusSelectionLists : serviceActions.updateStatusSelectionLists,
  };

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(RubyStatus));